import React, { useCallback, useState, useEffect } from 'react'
import { Select, Form, Button, Table, Space, Modal, DatePicker, Input, message, Row, Col } from 'antd';
import { SearchOutlined, RedoOutlined } from '@ant-design/icons';
import { store } from '@root/store';
import { getCountyBatch, updateCountyBatch } from "@root/common/service";
import type { ColumnsType } from 'antd/es/table';
import moment from "moment";
import "../_style.scss"

const { Option } = Select;
interface DataType {
  key: number | string;
  year: number | string;
  batchId: number;
  batchNumber: number;
  beginTime: string;
  endTime: string;
  provicneCode: string;
  provicneName: string;
  instituteName: string;
  instituteId: number | string;
  id: number;
}

function CountySet(props: any) {
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  // const [proId, setProId] = useState()
  const [dataSource, setDataSource] = useState<DataType[]>()
  const [isSetTimeVisible, setIsSetTimeVisible] = useState(false)
  const [provinceArr, setProvinceArr] = useState<any>([])
  const [timeItem, setTimeItem] = useState({ id: '', instituteName: '', beginTime: '', endTime: '' })
  const [nowYear, setNowYear] = useState<number>(2022)
  const [batch, setBatch] = useState<number>(1)

  const columns: ColumnsType<DataType> = [
    {
      title: '序号',
      render: (text, record, index) => `${index + 1}`,
      width: 80,
    },
    {
      title: '省份',
      dataIndex: 'provicneName',
      key: 'provicneName',
      width: 100,
    },
    {
      title: '县医院名称',
      dataIndex: 'instituteName',
      key: 'instituteName',
    },
    {
      title: '年度',
      dataIndex: 'year',
      key: 'year',
      width: 80,
    },
    {
      title: '批次',
      dataIndex: 'batchNumber',
      key: 'batchNumber',
      width: 80,
    },
    {
      title: '开始日期',
      dataIndex: 'beginTime',
      key: 'beginTime',
      width: 120,
    },
    {
      title: '截止日期',
      dataIndex: 'endTime',
      key: 'endTime',
      width: 120,
    },
    {
      title: '操作',
      dataIndex: 'set',
      key: 'set',
      width: 100,
      render: (_, e) => (
        <Space size="middle">
          <Button style={{ padding: '0' }} onClick={() => setTime(e)} type="link">设置时间</Button>
        </Space>
      ),
    },
  ];
  const getAll = async (e: any) => {
    const { rows } = await getCountyBatch({
      year: 2022,
      batch: 1,
      province: e,
      institute: ''
    })
    setDataSource(rows)
  }

  useEffect(() => {
    // setProId(props.proId) 
    const date = new Date()
    setNowYear(date.getFullYear())
    setBatch(1)
    console.log(store.getState());
    setProvinceArr(store.getState().directionaries.chinaProvinceData)
    getAll(props.proId)
  }, [props])

  const setTime = useCallback((e: any) => {
    console.log('setTime', e);
    // form2.resetFields();
    setTimeItem(e)
    form2.setFieldsValue({ startDate: moment(e.beginTime, 'YYYY-MM-DD'), endDate: moment(e.endTime, 'YYYY-MM-DD') })
    setIsSetTimeVisible(true)
  }, [form2])

  const setTimeCancel = useCallback((e: any) => {
    setIsSetTimeVisible(false)
  }, [])

  const handleChange = useCallback((e: any, a: any) => {
    console.log('选择结果', e, a);
    // setTimeItem(e)
  }, [])

  const onFinish = useCallback((e: any) => {
    console.log('onFinish', e);
    const getOne = async () => {
      const { rows } = await getCountyBatch({
        institute: e.county === undefined ? '' : e.county,
        year: e.year === undefined ? '2022' : e.year,
        batch: e.batch === undefined ? '' : e.batch,
        province: e.province === undefined ? '' : e.province
      })
      setDataSource(rows)
    }
    getOne()
  }, [])
  const setTimeFinish = useCallback((e: any) => {
    console.log('setTimeFinish', e);
    const setOne = async () => {
      const { code, msg } = await updateCountyBatch({
        id: timeItem.id,
        beginTime: moment(e.startDate).format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment(e.endDate).format('YYYY-MM-DD HH:mm:ss'),
      })
      if (code === 200) {
        message.success('更新成功');
        setIsSetTimeVisible(false)
        getAll(props.proId)
        // getAll(proId)
      } else {
        message.error(`更新失败,${msg}`);
      }
    }
    setOne()
  }, [timeItem, props])
  const onFinishFailed = useCallback(() => {
    console.log('onFinishFailed验证未通过');
  }, [])
  const onReset = useCallback(() => {
    form1.resetFields();
    // getAll(proId)
    getAll(props.proId)
  }, [form1, props])

  return (
    <>
      <div className='proBtn'>
        <Form
          name="provinceSet"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          form={form1}
          labelCol={{span: 8}}
          wrapperCol={{span: 16}}
        >
          <Row>
            <Col span={5}>
              <Form.Item
                label="年度"
                name="year"
              >
                <Select
                  placeholder="请选择年度"
                  onChange={handleChange}
                  allowClear
                >
                  <Option value={nowYear}>{nowYear}</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                label="批次"
                name="batch"
              >
                <Select
                  placeholder="请选择批次"
                  onChange={handleChange}
                  allowClear
                >
                  <Option value={batch}>{batch}</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="省份"
                name="province"
              >
                <Select
                  placeholder="请选择省份"
                  onChange={handleChange}
                  allowClear
                >
                  {provinceArr.map((e: any, i: number) => {
                    return <Option value={e.value} key={i}>{e.label}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="县医院名称"
                name="county"
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{textAlign: 'right'}}>
                <Button type="primary" htmlType="submit">查询</Button>
                <Button type="primary" onClick={onReset} style={{ marginLeft: '15px' }} >重置</Button>
            </Col>
          </Row>
        </Form>
      </div>
      <div className='boxTable'>
        <Table dataSource={dataSource} columns={columns} bordered scroll={{ y: 'calc(100vh - 250px)' }} />
      </div>
      <Modal title="设置时间" visible={isSetTimeVisible} onCancel={setTimeCancel} footer={[]} width='650px'>
        县医院名称：{timeItem.instituteName}
        <Form
          name="provinceSet"
          onFinish={setTimeFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ marginTop: '15px' }}
          layout='inline'
          initialValues={{ startDate: moment(timeItem.beginTime, 'YYYY-MM-DD'), endDate: moment(timeItem.endTime, 'YYYY-MM-DD') }}
          form={form2}
        >
          <Form.Item
            label="开始日期"
            name="startDate"
            rules={[{ required: true, message: '开始时间不可为空，请正确选择!' }]}
          >
            <DatePicker disabled onChange={handleChange} />
          </Form.Item>

          <Form.Item
            label="结束日期"
            name="endDate"
            rules={[{ required: true, message: '结束时间不可为空，请正确选择!' }]}
          >
            <DatePicker onChange={handleChange} />
          </Form.Item>

          <Form.Item style={{ display: 'flex', marginTop: '15px', width: '100%', justifyContent: 'center' }} >
            <Button onClick={setTimeCancel} style={{ marginRight: '15px' }} >取消</Button>
            <Button type="primary" htmlType="submit">保存</Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default CountySet